module.exports = __webpack_public_path__ + "static/media/Audiowide-Regular.1035cee0.ttf";